import React from 'react'
import Button from '@mui/material/Button'

import Loader from '../../Loader'
import { FormActionButtonProps } from '../propsTypes'

const FormActionButton = ({ text, onClick, disabledState, disabled }: FormActionButtonProps) => {
  return (
    <Button
      variant="contained"
      color="success"
      onClick={onClick}
      disabled={disabled}
      sx={{
        fontWeight: '600',
        color: 'rgba(0, 0, 0, 1)',
        background: 'rgba(42, 234, 250, 1)',
        margin: '30px 0 0 0',
        fontFamily: 'Space Grotesk, sans-serif',

        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 1)',
          background: 'rgba(42, 234, 250, 0.5)',
        },
        '&:hover': {
          background: 'rgba(255, 255, 255, 1)',
        },
        '@media (max-width: 1200px)': {
          width: '100%',
        },
      }}>
      {disabledState ? <Loader></Loader> : null}
      {text}
    </Button>
  )
}

export default FormActionButton
